import React from "react";
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const LstmModelInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
           <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is an LSTM Model?</h4>
          <p>
            A Long Short-Term Memory (LSTM) model is a type of recurrent neural network (RNN) specifically designed to
            process sequential data. It excels at learning dependencies in sequences, making it ideal for tasks such as
            time-series forecasting, speech recognition, and natural language processing (NLP).
          </p>
          <p>
            <b>Why is it important in trading?</b> LSTM models are widely used in trading and financial analysis for:
          </p>
          <ul>
            <li>Predicting future price movements based on historical data.</li>
            <li>Identifying trends and patterns in time-series data.</li>
            <li>Building algorithmic trading systems and strategies.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Key Components of an LSTM Model</h4>
          <p>
            <b>Forget Gate:</b> Decides what information to discard from the previous state.<br />
            <b>Input Gate:</b> Decides what new information to add to the current state.<br />
            <b>Output Gate:</b> Determines the final output based on the current state and hidden state.
          </p>
          <p>
            These gates allow the LSTM model to remember or forget information as needed, making it powerful for
            capturing long-term dependencies.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. Advantages of LSTMs</h4>
          <p>
            <b>Handles Sequential Data:</b> Designed to process and learn from sequential or time-series data.<br />
            <b>Remembers Long-Term Dependencies:</b> Unlike traditional RNNs, LSTMs mitigate the vanishing gradient
            problem, enabling them to capture long-term relationships.<br />
            <b>Versatile Applications:</b> Can be applied to a wide range of problems, including financial modeling,
            sentiment analysis, and more.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Applications of LSTMs in Trading</h4>
          <p>
            LSTM models are particularly useful in financial markets due to their ability to process time-series data
            effectively. Key applications include:
          </p>
          <ul>
            <li>Forecasting stock prices, forex rates, and commodity trends.</li>
            <li>Analyzing market sentiment from news or social media data.</li>
            <li>Developing predictive models for trading signals and strategies.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Limitations of LSTMs</h4>
          <p>
            While powerful, LSTMs have some limitations:
          </p>
          <ul>
            <li>Require a large amount of labeled data for accurate predictions.</li>
            <li>Computationally expensive and may take longer to train compared to simpler models.</li>
            <li>May overfit if not regularized properly.</li>
          </ul>
          <p>
            <b>Mitigation:</b> Techniques like dropout layers, proper hyperparameter tuning, and using ensembles can
            address these challenges.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LstmModelInfo;
